module.exports = __webpack_public_path__ + "img/happiness-guarantee-badge.f9b1fed.png?v=1744194310396";